






























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {TableEditType} from '@/enums/table';
import DeleteDialog from '@c/DeleteDialog.vue';
import ModulesEditDialog from './ModulesEditDialog.vue';
import MeasurementsEditDialog from './MeasurementsEditDialog.vue';
import {PModuleTableHeader} from '../interfaces';
import {getAllModules} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import {getAllTasks} from '@/store/modules/entities/pmodules/pmoduleTasksModule';

@Component({
  components: {
    DeleteDialog,
    ModulesEditDialog,
    MeasurementsEditDialog,
  },
})
export default class Table extends Vue {
  @Prop()
  modules!: string;

  @Prop()
  nodeId!: number;

  @Prop()
  buttonDisabled!: boolean;

  @Prop({required: false, default: false})
  filterModules?: boolean;

  @Prop({required: false, default: false})
  filterTasks?: boolean;

  pmodules: any[] = [];

  measurements: any[] = [];

  items: any[] = [];

  model: any = null;

  headers: PModuleTableHeader[] = [
    {
      text: 'Элемент',
      value: 'description',
      sortable: false,
    },
  ];

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  get editDialog() {
    return this.$refs.editDialog as any;
  }

  get measurementsDialog() {
    return this.$refs.measurementsDialog as any;
  }

  get actualHeaders() {
    const actionsSlice = [
      {
        text: 'Действия',
        value: 'actions',
        sortable: false,
        width: 90,
      },
    ];
    return [...this.headers, ...actionsSlice];
  }

  async created() {
    this.pmodules = this.filterTasks ? await getAllTasks() : await getAllModules();
    if (!this.modules) {
      this.items = [];
      return;
    }
    const m = JSON.parse(this.modules);
    this.update_items(m);
  }

  update_items(m: any) {
    this.items = (Array.isArray(m) ? m : Object.keys(m)).map((x: string, index: number) => {
      return {
        index: index,
        guid: x,
        description:
          this.pmodules.find(t => t.guid == x)?.name + (m[x] ? ' — ' + JSON.stringify(m[x]) : ''),
      };
    });
  }

  add() {
    const index = this.items.length ? this.items[this.items.length - 1].index + 1 : 0;
    this.openEditDialog(TableEditType.Add, {index: index, guid: null, description: null});
  }

  edit(item: any) {
    this.openEditDialog(TableEditType.Edit, item);
  }

  modifyMeasurements(item: any) {
    const {type, title} = this.getInitialParams(TableEditType.Edit);
    const m = JSON.parse(this.modules);
    this.model = {mesIds: [], guid: item.guid};
    this.measurements = this.pmodules
      .find(x => x.guid == item.guid)
      .measurements.map((m: any, index: number) => {
        this.model.mesIds.push(m.measurementId);
        return {
          ...m,
          index: index,
          name: m.measurementDescription,
          description: m.measurementDescription,
        };
      });
    if (Array.isArray(m[item.guid]) && m[item.guid].length > 0) {
      let selected: number[] = [];
      for (const mesId of m[item.guid]) {
        const ids = this.measurements
          .filter(m => m.measurementId == mesId)
          .map(m => m.measurementId);
        selected = selected.concat(this.model.mesIds.filter((x: number) => ids.includes(x)));
      }
      this.model.mesIds = selected;
    }

    const options = {
      type,
      title,
      saveCallback: (data: any) => {
        const m = JSON.parse(this.modules);
        m[data.guid] = [
          ...new Set(
            this.measurements
              .filter(m => data.mesIds.includes(m.measurementId))
              .map(m => m.measurementId),
          ),
        ];
        this.measurementsDialog.$refs.form.reset();
        this.measurementsDialog.close();
        this.update_items(m);
        this.$emit('update', JSON.stringify(m));
      },
    };
    this.measurementsDialog.open(this.model, options);
  }

  openEditDialog(actionType: TableEditType, item: any) {
    const {type, title} = this.getInitialParams(actionType);
    this.model = {...item};
    const options = {
      type,
      title,
      saveCallback: (data: any) => {
        let m = JSON.parse(this.modules);
        if (Array.isArray(m)) {
          m.push(data.guid);
          m = [...new Set(m)];
        } else {
          if (!m[data.guid]) {
            const mesIds: string[] = this.pmodules
              .find(x => x.guid == data.guid)
              .measurements.map((m: any) => m.measurementId);
            m[data.guid] = [].filter(x => mesIds.includes(x));
          }
        }
        this.editDialog.$refs.form.reset();
        this.editDialog.close();
        this.update_items(m);
        this.$emit('update', JSON.stringify(m));
      },
    };
    this.editDialog.open(this.model, options);
  }

  deleteItem(item: any) {
    this.deleteDialog.open(item, {
      deleteCallback: (item: any) => {
        let m = JSON.parse(this.modules);
        if (Array.isArray(m)) {
          m = [...new Set(m.filter(x => x.guid != item.guid))];
        } else {
          delete m[item.guid];
        }
        this.deleteDialog.close();
        this.update_items(m);
        this.$emit('update', JSON.stringify(m));
      },
    });
  }

  getInitialParams(actionType: TableEditType) {
    let params;
    switch (actionType) {
      case TableEditType.Add:
        params = {
          type: 'add',
          title: 'Создание',
        };
        break;
      case TableEditType.Edit:
        params = {
          type: 'edit',
          title: 'Редактирование',
        };
        break;
    }
    return params;
  }
}
